import React, { useEffect, useState } from 'react';
import {
  CSpinner, CButton, CRow, CCol, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter
} from '@coreui/react';
import CustomAgGrid from './../../components/shared/CustomAgGrid';
import ProviderAddForm from './ProviderAddForm.jsx';
import fetchPatientData from "../../services/general/patientGeneralAPI.api.js";
import Pageloader from "../../components/shared/Pageloader";
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config.js';

const ProviderMaster = () => {
 // const buttonList = [{ Name: 'Edit' }, { Name: 'Delete' }];
    const buttonList = [{ Name: 'Edit' }];
  const [providerList, setProviderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedProviderID, setSelectedProviderID] = useState(-1)
  const [selectProviderDetails, setselectProviderDetails] = useState({})
  const [selectProviderInsurances, setselectProviderInsurances] = useState({})
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectProviderFacilities, setselectProviderFacilities] = useState({})
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false)
  const [deleteProviderID, setDeleteProviderID] = useState(null)
  const [deleteProviderName, setDeleteProviderName] = useState('')
  const handleOnClick = async (type, e) => {
    if (type == "EDIT") {
      handleEdit(e)
    } 
    // else if (type == "DELETE") {
    //   handleDelete(e)
    // }

  }

  const handleDelete = async (e) => {
    setDeleteProviderID(e.ID)
    setDeleteProviderName(e.Name)
    setDeleteConfirmVisible(true)
  }

  const confirmDeleteProvider = async () => {
    if (!deleteProviderID) {
      toast.error('Delete ID not found', toastConfig)
      return
    }

    setLoading(true)
    try {
      const provider = {
        ID: deleteProviderID
      }
      await fetchPatientData("DELETE", "Provider", JSON.stringify(provider))
      await getData()
      toast.success('Provider deleted successfully', toastConfig)
      setDeleteConfirmVisible(false)
      setDeleteProviderID(null)
      setDeleteProviderName('')
    } catch (error) {
      console.log(error)
      toast.error('Failed to delete provider', toastConfig)
      setLoading(false)
    }
  }
  const handleEdit = async (e) => {
    setLoading(true);
    setSelectedRow(e)
    const provider = {
      ID: e.ID
    };
    let providerData = await fetchPatientData("SELECTALL", "Provider", JSON.stringify(provider));
    let insuranceData = JSON.parse(providerData.d)?.Insurance;
    let facilityData = JSON.parse(providerData.d)?.Facility;
    // setselectProviderInsurances(insuranceData)
    // setselectProviderFacilities(facilityData) 
    let providerDetails = {
      "Details": e,
      "Insurances": insuranceData,
      "facilities": facilityData
    }
    setselectProviderDetails(providerDetails)
console.log(providerDetails, 'providerDetails')
    setLoading(false);
    setModalVisible(true);

    // Handle the row click event
  };

  const getData = async () => {
    setIsPageLoading(true)
    try {
      // Fetch provider data
      let providerData = await fetchPatientData("SELECT", "Provider", "{}");
      providerData = JSON.parse(providerData.d)?.Data;
      setProviderList(providerData);
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAddProvider = () => {
    setSelectedRow({});
    setModalVisible(true);
  };

  console.log(providerList,'providerList')

  return (
    <>
      <div className='position-relative patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme min-vh-100'>
        <Pageloader isLoading={isPageLoading} />
        {/* <CCard className="m-2">
          <CCardBody>
            <CRow>
              <CCol sm={4}>
                <CButton style={{ marginTop: "10px" }} onClick={handleAddProvider} variant="outline" color="primary">
                  + Add Provider
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard> */}

        <CustomAgGrid className="provider-master-theme__grid" rowClickedFn={handleOnClick} callFrom="Provider" options={providerList.map(({AddressDetails, ProviderData, ...rest}) => rest)} btnList={buttonList} />

        {modalVisible && (
          <ProviderAddForm setselectProviderDetails={setselectProviderDetails} setSelectedRow={setSelectedRow} getDataListProvider={getData} providerID={selectedProviderID} selectedRow={selectedRow} selectedDetails={selectProviderDetails} formVisible={modalVisible} onClose={() => setModalVisible(false)} />
        )}

        <CModal visible={deleteConfirmVisible} onClose={() => setDeleteConfirmVisible(false)} centered backdrop={'static'}>
          <CModalHeader onClose={() => setDeleteConfirmVisible(false)}>
            <CModalTitle>Delete Provider</CModalTitle>
          </CModalHeader>
          <CModalBody>
            Are you sure you want to delete this provider?
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setDeleteConfirmVisible(false)}>
              Close
            </CButton>
            <CButton color="danger" variant="outline" onClick={confirmDeleteProvider}>
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </>
  );
};

export default ProviderMaster;
